import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewEncapsulation,
  OnInit,
} from '@angular/core';
import { Theme } from '@modules/button/enums/theme.enum';
import { FontSize } from '@modules/button/enums/font-size.enum';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ButtonComponent implements OnInit {
  buttonTheme: string = Theme.Primary;
  fontColor: string | null = null;
  icon: boolean = false;
  color: string = '';
  typeButton: string = 'button';

  @HostBinding('style.width') widthHost = 'auto';

  @Input() iconReverse: boolean = false;
  @Input() height: string | null = '50px';
  @Input() width: string | null = '100%';
  @Input() fontSize: string | null = FontSize.md;
  @Input() fontWeight: string = '700';
  @Input() isLoading: boolean = false;
  @Input() skeletonStyles: any = {};
  @Input() disabled: boolean = false;
  @Input() idButton: string = '';

  @Input() set isForm(value: boolean) {
    this.typeButton = value ? 'submit' : 'button';
  }

  @Input() set colorClass(color: string) {
    this.color = color;
  }

  ngOnInit(): void {
    this.widthHost = this.width as string;
  }

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  @Input()
  set type(type: string) {
    const selectedButtonType =
      type === Theme.Primary ||
      type === Theme.Secondary ||
      type === Theme.Tertary ||
      type === Theme.Quaternary ||
      type === Theme.Link;

    this.buttonTheme = selectedButtonType ? type : Theme.Primary;
  }

  onClickButton() {
    this.onClick.emit();
  }

  slotChange($event) {
    const assigned = $event.target.assignedNodes();
    if (assigned.length > 0) {
      this.icon = true;
    }
  }

  get Type(): typeof Theme {
    return Theme;
  }

  get TypeClassButton() {
    switch (this.buttonTheme) {
      case this.Type.Primary:
        return 'btn-primary';
      case this.Type.Secondary:
        return 'btn-secondary';
      case this.Type.Tertary:
        return 'btn-tertary';
      case this.Type.Link:
        return 'btn-link';
      case this.Type.Quaternary:
        return 'btn-quaternary';

      default:
        return 'btn-primary';
    }
  }
}
